<div
  class="group-header"
  data-cy="group-header"
  role="button"
  tabindex="0"
  (click)="onHeaderClick()"
  (keydown.enter)="onHeaderClick()"
  (keydown.space)="onHeaderClick()"
>
  <span class="break-type-badge">{{
    group.displayName || group.breakType
  }}</span>
  <span class="coded-indicator">{{ codedIndicator }}</span>
  <span
    class="pill"
    [class.pill-complete]="validation.complete"
    [class.pill-incomplete]="!validation.complete"
  >
    {{ validation.complete ? 'Complete' : 'Incomplete' }}
  </span>
  <span
    *ngIf="saveState !== 'idle'"
    class="save-badge"
    [class.save-badge-saving]="saveState === 'saving'"
    [class.save-badge-saved]="saveState === 'saved'"
    [class.save-badge-failed]="saveState === 'failed'"
    data-cy="group-save-badge"
  >
    {{
      saveState === 'saving'
        ? 'Saving…'
        : saveState === 'saved'
        ? 'Saved'
        : 'Failed'
    }}
  </span>
</div>

<div class="group-body" *ngIf="expanded" [formGroup]="form">
  <div
    *ngIf="existingCodesInfo"
    class="existing-codes-info"
    data-cy="group-existing-info"
  >
    {{ existingCodesInfo }}
  </div>

  <div *ngIf="isMixed" class="group-blocker" data-cy="group-blocker">
    These breaks span clients with different break-code sets and cannot be coded
    together. Narrow the selection to a single code set.
  </div>

  <ng-container *ngIf="!isMixed">
    <div class="field-row" *ngIf="hasWriteTarget">
      <nf-form-control
        *ngIf="isReady && actionCodes.length > 0 && hasActionWriteTarget"
        label="Action"
        compact
        data-cy="group-action"
      >
        <ng-select
          [items]="actionCodes"
          placeholder="Select Action"
          formControlName="action"
          [closeOnSelect]="true"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item
            }}<span
              *ngIf="notesRequiredActionCodeSet.has(item)"
              class="notes-required-diamond"
            >
              ◆</span
            >
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div [ngbTooltip]="item" container="body" class="ellipsis">
              {{ item
              }}<span
                *ngIf="notesRequiredActionCodeSet.has(item)"
                class="notes-required-diamond"
              >
                ◆</span
              >
            </div>
          </ng-template>
        </ng-select>
      </nf-form-control>

      <nf-form-control
        *ngIf="
          isReady && descriptionCodes.length > 0 && hasDescriptionWriteTarget
        "
        label="Description"
        compact
        data-cy="group-description"
      >
        <ng-select
          [items]="descriptionCodes"
          placeholder="Select Description"
          formControlName="description"
          [closeOnSelect]="true"
        >
          <ng-template ng-option-tmp let-item="item">
            <div [ngbTooltip]="item" container="body" class="ellipsis">
              {{ item }}
            </div>
          </ng-template>
        </ng-select>
      </nf-form-control>
    </div>

    <nf-form-control
      [label]="validation.noteRequired ? 'Note (required)' : 'Note'"
      [customErrorMessages]="noteValidationMessages"
      data-cy="group-note"
    >
      <textarea
        class="form-control"
        rows="2"
        formControlName="note"
        [placeholder]="notePlaceholder"
      ></textarea>
    </nf-form-control>
  </ng-container>
</div>
